export function isChartValuesEmpty(data: { value: number }[]) {
  return data.every((item) => item.value === 0);
}

